import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/nasscom_thumb.png"

export function Index() {
  return (
    <Layout
      title="NASSCOM Sponsor Engagement & Attendee Success with Premagic AI Photos"
      description="How NASSCOM enhanced sponsor ROI and attendee engagement across Indian tech events using Premagic's AI photo platform for powerful sponsor activations."
      metaImage={ThumbnailImage}
      keywords={[
        "NASSCOM case study, Indian IT industry events, tech sponsor engagement, IT industry networking, Indian tech conferences, NASSCOM member events, tech industry photos, IT sponsor activation, Indian technology events, software industry networking, IT association events, tech industry marketing, Indian IT ecosystem, technology sponsor ROI, IT community building",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "NASSCOM", url: "/case-study/nasscom/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "NASSCOM Sponsor Engagement & Attendee Success with Premagic AI Photos",
            "description": "How NASSCOM enhanced sponsor ROI and attendee engagement across Indian tech events using Premagic's AI photo platform for powerful sponsor activations.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.NASSCOM} />
    </Layout>
  )
}

export default Index
